import { ApiBase } from "@/api/ApiBase";

export interface ResultadoCategoria {
  nome: string;
  tipo: "sucesso" | "erro";
  msg: string;
  codigo?: string;
}

export interface AddCategoriasResponse {
  msg: string;
  tipo: "sucesso" | "erro" | "parcial";
  resultados: ResultadoCategoria[];
}

export interface CategoriaResumo {
  id: number;
  nome: string;
  codigo: string;
  totalArtigos: number;
}

export interface ListaCategoriasResponse {
  categorias: CategoriaResumo[];
  totalGeralCategorias: number;
}

export interface CategoriaDetalhe {
  id: number;
  nome: string;
  codigo: string;
  canal: string;
  dataCriacao: string;
  dataAlteracao: string | null;
  criador: { nome: string } | null;
}

export interface EditarApagarCategoriaResponse {
  msg: string;
  tipo: "sucesso" | "erro";
}

export const LIMITE_CATEGORIAS_POR_REQUISICAO = 20;
export const CATEGORIAS_POR_PAGINA = 100;

export class CategoriaApi extends ApiBase {
  adicionar(nomes: string[]): Promise<AddCategoriasResponse> {
    const params = new URLSearchParams();
    for (const nome of nomes) params.append("nomes", nome);
    return this.http.post<AddCategoriasResponse>(
      "/api/facturacao/categoria/add",
      params,
    );
  }

  listar(pagina: number): Promise<ListaCategoriasResponse> {
    return this.http.put<ListaCategoriasResponse>(
      `/api/facturacao/categoria/lista-by-comerciante/${pagina}`,
    );
  }

  obterPorCodigo(codigo: string): Promise<CategoriaDetalhe> {
    return this.http.put<CategoriaDetalhe>(
      `/api/facturacao/categoria/get-one-by-codigo/${encodeURIComponent(
        codigo,
      )}`,
    );
  }

  editar(codigo: string, nome: string): Promise<EditarApagarCategoriaResponse> {
    return this.http.post<EditarApagarCategoriaResponse>(
      "/api/facturacao/categoria/edit",
      { codigo, nome },
    );
  }

  apagar(codigo: string): Promise<EditarApagarCategoriaResponse> {
    return this.http.post<EditarApagarCategoriaResponse>(
      "/api/facturacao/categoria/delete",
      { codigo },
    );
  }
}
